import * as actions from '../../actions/shared/shared.actions';
import { createReducer, on } from '@ngrx/store';
import { PermissionType } from '@app-services/requests/models/permission-type.model';

export interface SharedState {
  permissions: PermissionType[];
}

export const SharedInitialState: SharedState = {
  permissions: null,
};

// tslint:disable-next-line: variable-name
const _sharedReducer = createReducer(
  SharedInitialState,
  on(actions.getPermissionTypes, (state) => ({ ...state })),

  on(actions.getPermissionTypesSuccess, (state, { permissions }) => ({
    ...state,
    permissions,
  }))
);

export function sharedReducer(state, action) {
  return _sharedReducer(state, action);
}
